import React from 'react';
import { sanitizeData } from '../dataSanitizeUtils';
import { Activity } from '../types';
import botMessageStyles from './BotMessage.module.css';
import styles from './LiveChatAgentMessage.module.css';
import sharedStyles from '../shared.module.css';
import { renderAsMarkdown } from '../helpers';

export const LiveChatAgentMessage: React.FC<{
    activity: Activity;
    idx: number;
    lastMessageFrom: string;
}> = ({ activity, idx, lastMessageFrom }) => {
    const sanitizedText = sanitizeData(activity.value.text);
    return (
        <div
            id={`liveChatAgentMessage-${idx}`}
            className={sharedStyles.botMessageNoBubble}
        >
            <React.Fragment key={'agent-label-' + idx}>
                {lastMessageFrom === 'user' || idx === 0 ? (
                    <div className={sharedStyles.botMessageContainer}>
                        <div className={botMessageStyles.botMessageNameLabel}>
                            Agent
                        </div>
                    </div>
                ) : null}
                <div className={sharedStyles.botMessageContainer}>
                    <div
                        className={`${sharedStyles.botMessageBubble} ${styles.liveChatBotMessageBubble}`}
                        data-lc-msg="true"
                        dangerouslySetInnerHTML={{
                            __html: renderAsMarkdown(sanitizedText),
                        }}
                    ></div>
                </div>
            </React.Fragment>
        </div>
    );
};
